import React, { useEffect, useState, useRef } from "react";

//jquery
import $ from "jquery";

//redux
import { connect, useSelector } from "react-redux";

//action
import { getVideo, deleteVideo } from "../../store/video/action";

//routing
import { Link, useHistory } from "react-router-dom";

// dayjs
import dayjs from "dayjs";

import { permissionError, alert } from "../../util/Alert";

//pagination
import Pagination from "../../pages/Pagination";

//MUI icon
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import { Tooltip, Button } from "@material-ui/core";

// Components
import DeleteReelConfirmationDialog from "../dialog/DeleteReelConfirmationDialog";

//Date Range Picker
import { DateRangePicker } from "react-date-range";
//Calendar Css
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

//image
import noImage from "../../assets/images/noImage.png";

const VideoTable = (props) => {
  const history = useHistory();

  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const videoRefs = useRef({});
  const popupVideoRefs = useRef({});

  // Hover popup state
  const [hoveredVideo, setHoveredVideo] = useState(null);
  const [popupPosition, setPopupPosition] = useState({ x: 0, y: 0 });
  const [videoProgress, setVideoProgress] = useState({});
  const [videoDuration, setVideoDuration] = useState({});
  const [hoveredThumbnail, setHoveredThumbnail] = useState(null);

  // Delete popup state
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [selectedVideoId, setSelectedVideoId] = useState(null);
  const [selectedReason, setSelectedReason] = useState("");
  const [selectedVideoData, setSelectedVideoData] = useState(null);

  const [date, setDate] = useState([]);
  const [sDate, setsDate] = useState("ALL");
  const [eDate, seteDate] = useState("ALL");

  const maxDate = new Date();
  useEffect(() => {
    $("#card").click(() => {
      $("#datePicker").removeClass("show");
    });
  }, []);

  useEffect(() => {
    props.getVideo(null, activePage, rowsPerPage, sDate, eDate); // eslint-disable-next-line
  }, [activePage, rowsPerPage, sDate, eDate]);

  const { video, totalVideo } = useSelector((state) => state.video);

  const hasPermission = useSelector((state) => state.admin.admin.flag);

  useEffect(() => {
    setData(video);
  }, [video]);

  useEffect(() => {
    if (date.length === 0) {
      setDate([
        {
          startDate: new Date(),
          endDate: new Date(),
          key: "selection",
        },
      ]);
    }
    $("#datePicker").removeClass("show");
    setData(video);
  }, [date, video]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const handleVideoPlay = (index, isPopup = false) => {
    const videoRef = isPopup
      ? popupVideoRefs.current[`popup_video_${index}`]
      : videoRefs.current[`video_${index}`];
    if (videoRef) {
      if (videoRef.paused) {
        videoRef.play();
      } else {
        videoRef.pause();
      }
    }
  };

  const handleVideoMute = (index, isPopup = false) => {
    const videoRef = isPopup
      ? popupVideoRefs.current[`popup_video_${index}`]
      : videoRefs.current[`video_${index}`];
    if (videoRef) {
      videoRef.muted = !videoRef.muted;
    }
  };

  const handleSeekChange = (index, value) => {
    const videoRef = popupVideoRefs.current[`popup_video_${index}`];
    if (videoRef && videoDuration[`popup_video_${index}`]) {
      const newTime = (value / 100) * videoDuration[`popup_video_${index}`];
      videoRef.currentTime = newTime;
    }
  };

  const handleVideoClick = (event, videoData, index) => {
    const rect = event.currentTarget.getBoundingClientRect();
    setPopupPosition({
      x: rect.left + rect.width + 10,
      y: rect.top,
    });
    setHoveredVideo({ ...videoData, index });
  };

  const handleVideoPopupClose = () => {
    setHoveredVideo(null);
  };

  const handleThumbnailHover = (index) => {
    setHoveredThumbnail(index);
  };

  const handleThumbnailLeave = () => {
    setHoveredThumbnail(null);
  };

  const updateVideoProgress = (index) => {
    const videoRef = popupVideoRefs.current[`popup_video_${index}`];
    if (videoRef) {
      const progress = (videoRef.currentTime / videoRef.duration) * 100;
      setVideoProgress((prev) => ({
        ...prev,
        [`popup_video_${index}`]: progress || 0,
      }));
    }
  };

  const handleVideoLoadedMetadata = (index) => {
    const videoRef = popupVideoRefs.current[`popup_video_${index}`];
    if (videoRef) {
      setVideoDuration((prev) => ({
        ...prev,
        [`popup_video_${index}`]: videoRef.duration,
      }));
    }
  };

  const formatTime = (seconds) => {
    if (!seconds || isNaN(seconds)) return "0:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${mins}:${secs.toString().padStart(2, "0")}`;
  };

  const handleDelete = (videoId, videoData) => {
    setSelectedVideoId(videoId);
    setSelectedVideoData(videoData);
    setShowDeletePopup(true);
    setSelectedReason("");
  };

  const handleDeleteConfirm = (reasonValue, reasonTitle) => {
    if (!hasPermission) return permissionError();

    props.deleteVideo(selectedVideoId, reasonTitle);
    alert(
      "Deleted!",
      `Relite has been deleted! Reason: ${reasonTitle}`,
      "success",
    );

    setShowDeletePopup(false);
    setSelectedVideoId(null);
    setSelectedReason("");
    setSelectedVideoData(null);
  };

  const handleDeleteCancel = () => {
    setShowDeletePopup(false);
    setSelectedVideoId(null);
    setSelectedReason("");
    setSelectedVideoData(null);
  };

  const getAllVideo = () => {
    setActivePage(1);
    setsDate("ALL");
    seteDate("ALL");
    $("#datePicker").removeClass("show");
    props.getVideo(null, activePage, rowsPerPage, sDate, eDate);
  };

  const collapsedDatePicker = () => {
    $("#datePicker").toggleClass("collapse");
  };

  return (
    <>
      <div className="page-title">
        <div className="row">
          <div className="col-12 col-md-6 order-md-1 order-last">
            <h3 className="mb-3 text-light">Relite</h3>
          </div>
          <div className="col-12 col-md-6 order-md-2 order-first">
            <nav
              aria-label="breadcrumb"
              className="breadcrumb-header float-start float-lg-end"
            >
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <Link to="/admin/dashboard" className="text-danger">
                    Dashboard
                  </Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Relite
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <div className="row" style={{ marginBottom: "150px" }}>
        <div className="col">
          <div className="card" id="card">
            <div className="card-header pb-0">
              <div className="row my-3">
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-8 float-left">
                  <div className="text-left align-sm-left d-md-flex d-lg-flex justify-content-start">
                    <button
                      className="btn btn-info"
                      style={{ marginRight: 5 }}
                      onClick={getAllVideo}
                    >
                      All
                    </button>
                    <button
                      className="collapsed btn btn-info ml-5"
                      value="check"
                      data-toggle="collapse"
                      data-target="#datePicker"
                      onClick={collapsedDatePicker}
                    >
                      Analytics
                      <ExpandMoreIcon />
                    </button>
                    <p style={{ paddingLeft: 10 }} className="my-2 ">
                      {sDate !== "ALL" && sDate + " to " + eDate}
                    </p>
                  </div>
                </div>
                <div className="col-xs-12 col-sm-12 col-md-6 col-lg-4 float-right"></div>
                <div
                  id="datePicker"
                  className="collapse mt-5 pt-5"
                  aria-expanded="false"
                >
                  <div className="container table-responsive">
                    <div key={JSON.stringify(date)}>
                      <DateRangePicker
                        maxDate={maxDate}
                        onChange={(item) => {
                          setDate([item.selection]);
                          const dayStart = dayjs(
                            item.selection.startDate,
                          ).format("M/DD/YYYY");
                          const dayEnd = dayjs(item.selection.endDate).format(
                            "M/DD/YYYY",
                          );
                          setActivePage(1);
                          setsDate(dayStart);
                          seteDate(dayEnd);
                          props.getVideo(
                            null,
                            activePage,
                            rowsPerPage,
                            sDate,
                            eDate,
                          );
                        }}
                        showSelectionPreview={true}
                        moveRangeOnFirstSelection={false}
                        ranges={date}
                        direction="horizontal"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card-body card-overflow">
              <table className="table table-striped table-center ">
                <thead className="text-center">
                  <tr>
                    <th>No.</th>
                    <th>Video</th>
                    <th>Location</th>
                    <th>Like</th>
                    <th>Comment</th>
                    <th>Created At</th>
                    <th>Detail</th>
                    <th>Delete</th>
                  </tr>
                </thead>
                <tbody className="text-center">
                  {data.length > 0 ? (
                    data.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{index + 1}</td>
                          <td
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              flexDirection: "column",
                            }}
                          >
                            <div
                              style={{
                                position: "relative",
                                display: "inline-block",
                              }}
                              onClick={(e) => handleVideoClick(e, data, index)}
                              onMouseEnter={() => handleThumbnailHover(index)}
                              onMouseLeave={handleThumbnailLeave}
                            >
                              <img
                                height="100px"
                                width="100px"
                                src={data.thumbnail ? data.thumbnail : noImage}
                                className="post-image"
                                alt="Video thumbnail"
                                style={{
                                  boxShadow:
                                    "0 5px 15px 0 rgb(105 103 103 / 0%)",
                                  border: "2px solid #fff",
                                  borderRadius: 10,
                                  objectFit: "cover",
                                  cursor: "pointer",
                                }}
                              />

                              {/* Play Icon Overlay on Hover */}
                              {hoveredThumbnail === index && (
                                <div
                                  style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    backgroundColor: "rgba(0, 0, 0, 0.7)",
                                    borderRadius: "50%",
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    color: "white",
                                    fontSize: "18px",
                                    pointerEvents: "none",
                                  }}
                                >
                                  ▶️
                                </div>
                              )}
                            </div>
                          </td>
                          <td>{data.location ? data.location : "-"}</td>
                          <td className="text-danger">{data.like}</td>
                          <td className="text-success">{data.comment}</td>
                          <td>{data.date}</td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-sm btn-info"
                              onClick={() => {
                                localStorage.setItem(
                                  "VideoDetail",
                                  JSON.stringify(data),
                                );
                                history.push("/admin/video/detail");
                              }}
                            >
                              Detail
                            </button>
                          </td>
                          <td>
                            <Tooltip title="Delete">
                              <button
                                type="button"
                                className="btn bg-danger btn-sm"
                                onClick={() => handleDelete(data._id, data)}
                              >
                                <i className="fas text-light fa-trash-alt"></i>
                              </button>
                            </Tooltip>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan="8" align="center">
                        Nothing to show!!
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={totalVideo}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* Video Hover Popup */}
      {hoveredVideo && (
        <>
          {/* Backdrop */}
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 9998,
            }}
            onClick={handleVideoPopupClose}
          />

          {/* Popup */}
          <div
            style={{
              position: "fixed",
              top: popupPosition.y,
              left: popupPosition.x,
              width: "480px",
              backgroundColor: "#fff",
              border: "2px solid #ddd",
              borderRadius: "6px",
              boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
              zIndex: 9999,
            }}
          >
            {/* Close Button */}
            <button
              onClick={handleVideoPopupClose}
              style={{
                position: "absolute",
                top: "8px",
                right: "8px",
                background: "rgba(0, 0, 0, 0.7)",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "30px",
                height: "30px",
                cursor: "pointer",
                zIndex: 10000,
                fontSize: "14px",
              }}
            >
              ✕
            </button>

            <div
              style={{
                position: "relative",
                width: "100%",
                maxHeight: "360px",
              }}
            >
              <video
                ref={(ref) =>
                  (popupVideoRefs.current[`popup_video_${hoveredVideo.index}`] =
                    ref)
                }
                src={hoveredVideo.video ? hoveredVideo.video : noImage}
                muted
                style={{
                  width: "100%",
                  maxHeight: "360px",
                  objectFit: "contain",
                  borderRadius: "5px",
                }}
                autoPlay
                onLoadedMetadata={() =>
                  handleVideoLoadedMetadata(hoveredVideo.index)
                }
                onTimeUpdate={() => updateVideoProgress(hoveredVideo.index)}
              />

              {/* Custom Controls Overlay */}
              <div
                style={{
                  position: "absolute",
                  bottom: "0",
                  left: "0",
                  right: "0",
                  background: "linear-gradient(transparent, rgba(0,0,0,0.7))",
                  padding: "10px",
                  borderRadius: "0 0 5px 5px",
                }}
              >
                {/* Seek Bar */}
                <div style={{ marginBottom: "8px" }}>
                  <input
                    type="range"
                    min="0"
                    max="100"
                    value={
                      videoProgress[`popup_video_${hoveredVideo.index}`] || 0
                    }
                    onChange={(e) =>
                      handleSeekChange(hoveredVideo.index, e.target.value)
                    }
                    style={{
                      width: "100%",
                      height: "4px",
                      background: "#ddd",
                      outline: "none",
                      borderRadius: "2px",
                    }}
                  />
                </div>

                {/* Control Buttons and Time */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div style={{ display: "flex", gap: "8px" }}>
                    <button
                      type="button"
                      onClick={() => handleVideoPlay(hoveredVideo.index, true)}
                      style={{
                        background: "rgba(255,255,255,0.9)",
                        border: "none",
                        borderRadius: "4px",
                        padding: "4px 8px",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      ▶️
                    </button>
                    <button
                      type="button"
                      onClick={() => handleVideoMute(hoveredVideo.index, true)}
                      style={{
                        background: "rgba(255,255,255,0.9)",
                        border: "none",
                        borderRadius: "4px",
                        padding: "4px 8px",
                        fontSize: "12px",
                        cursor: "pointer",
                      }}
                    >
                      🔊
                    </button>
                  </div>

                  {/* Time Display */}
                  <div style={{ color: "#fff", fontSize: "12px" }}>
                    {formatTime(
                      ((videoProgress[`popup_video_${hoveredVideo.index}`] ||
                        0) *
                        (videoDuration[`popup_video_${hoveredVideo.index}`] ||
                          0)) /
                        100,
                    )}{" "}
                    /{" "}
                    {formatTime(
                      videoDuration[`popup_video_${hoveredVideo.index}`] || 0,
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}

      {/* Delete Confirmation Dialog */}
      <DeleteReelConfirmationDialog
        open={showDeletePopup}
        onClose={handleDeleteCancel}
        onConfirm={handleDeleteConfirm}
        selectedReason={selectedReason}
        setSelectedReason={setSelectedReason}
        itemData={selectedVideoData}
        itemType="video"
        title="Delete Video"
      />
    </>
  );
};

export default connect(null, { getVideo, deleteVideo })(VideoTable);
